import { Text } from '@chakra-ui/react'
import cn from 'classnames'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'
import * as S from './styles'
import { IFonts } from '@interfaces'
import Link from '../../ui/Link/Link'
import { getLocalizedPath } from '@utils'

interface II18nWidget {
  isSticky?: boolean
  onDrawerMenu?: boolean
  activeFontFamily?: IFonts
}

const I18nWidget = ({
  isSticky = false,
  onDrawerMenu = false,
}: II18nWidget) => {
  const { locale, asPath } = useRouter()
  const { t } = useTranslation()
  const targetLocale = locale === 'tr' ? 'en' : 'tr'
  const localizedHref = getLocalizedPath(asPath || '/', targetLocale)

  return (
    <S.I18nWidget>
      <Link
        href={localizedHref}
        locale={targetLocale}
        className={cn('I18nWidget__Link', {
          'I18nWidget__Link--isSticky': isSticky,
          'I18nWidget__Link--onDrawer': onDrawerMenu,
        })}
      >
        <Text
          as="span"
          color="white.primary"
          fontSize="17px"
          fontFamily="heading"
          mr="10px"
        >
          {t(locale === 'tr' ? 'nav:en' : 'nav:tr')}
        </Text>
      </Link>
    </S.I18nWidget>
  )
}

export default I18nWidget
